define('instrumentation/activityManager', [
    'lib/jquery',
    'lib/underscore',
    'instrumentation/util',
    'instrumentation/log-level',
    'instrumentation/log-category',
    'instrumentation/ariaApplicationLogListener',
    'instrumentation/event-formatter',
    'instrumentation/console-listener'
], function ($, _, util, LOGLEVEL, LOGCATEGORY, AriaAppLogListener, EventFormatter, ConsoleListener) {

    var event = { BEFORESEND: 'beforeSend', SUCCESS: 'success', COMPLETE: 'complete', ERROR: 'error' },
        activities = {},
        isOnlyIncludeSpecifiedAjaxCalls = false,
        isInitialized = false,
        scenarioNameIdMapping;

    var applicationSystemName = 'clientcenter';

    var ariaAppLogListener, consoleListener;
    var activityManager = {

        options: {
            getAppSubSystemNameFunc: function() { return ''; },
            getCustomerIdFunc: function() { return ''; },
            getAccountIdFunc: function() { return ''; },
            getSessionIdFunc: function() { return ''; },
            getUserIdFunc: function() { return ''; },
            getLcidFunc: function() { return ''; },
            getRequestIdFunc: function() { return ''; },
            getDeviceFunc: function() { return ''; },
            detectError: function() { return { pass:true }; },
            isStubbingAjax: true,
            applicationLogLevel: window.BINGADS_DEBUG !== true ? LOGLEVEL.INFO : LOGLEVEL.VERBOSE
        },

        logCategory: LOGCATEGORY,

        logLevel: LOGLEVEL,

        init: function(options) {
            var self = this;
            $.extend(self.options, options);
            self._initLoggers();

            if (self.options.isStubbingAjax) {
                self._stubAjax($);
            }
            scenarioNameIdMapping = {};

            isInitialized = true;

            if (window.BINGADS_DEBUG !== true) {
                window.onerror = function(errorMsg, url, lineNumber, column, errorObj) {
                    var errorMessage = errorMsg + '\tScript: ' + url + ' Line: ' + lineNumber;
                    if (!util.isUndefined(column)) {
                        errorMessage += ' Column: ' + column;
                    }
                    if (util.isObject(errorObj) && errorObj.hasOwnProperty('stack')) {
                        errorMessage += ' StackTrace: ' + errorObj.stack;
                    }

                    self.logMessage(errorMessage, '', [self.logCategory.ERROR], self.logLevel.INFO, '');
                    return true;
                };

                window.addEventListener('unhandledrejection', function(e) {
                    var rejection = e
                    // bluebird also adds an event to window, whose API is different from native one
                    // chekcing if it is a non-standard event generated by bluebird
                    if (e.detail) {
                        e.preventDefault();
                        rejection = e.detail;
                    }
                    var errorMessage = 'Unhandled Rejection: ';
                    // rejection reason could be an error instance or anything else
                    if (rejection.reason && (rejection.reason.message || rejection.reason.stack)) {
                        errorMessage = errorMessage + rejection.reason.message + ' StackTrace: ' + rejection.reason.stack;
                    } else if (util.isObject(rejection.reason) || util.isArray(rejection.reason)) {
                        errorMessage = errorMessage + JSON.stringify(rejection.reason);
                    } else {
                        errorMessage = errorMessage + rejection.reason;
                    }
                    self.logMessage(errorMessage, '', [self.logCategory.ERROR], self.logLevel.INFO, '');
                });
            }

            document.addEventListener('click', function(e) {
                self.logClickEvent(e);
            }, { passive: true });

            document.addEventListener('keydown', function(e) {
                self.logKeydownEvent(e);
            }, { passive: true });

            document.addEventListener('change', function(e) {
                self.logChangeEvent(e);
            }, { passive: true });

            self.logFullPageLoad();
        },

        _initLoggers: function () {
            var listenerOptions = {
                applicationSystem: applicationSystemName,
                applicationLogLevel: this.options.applicationLogLevel,
            };

            ariaAppLogListener = new AriaAppLogListener(listenerOptions);
            consoleListener = new ConsoleListener(listenerOptions);
        },

        flushLogs: function (callback) {
            if (isInitialized) {
                consoleListener.flushLogs();
                ariaAppLogListener.flushLogs(callback);
            } else {
                (_.isFunction(callback) ? callback : _.noop)();
            }
        },

        _log: function (logMessage) {
            var logMsg;
            if (isInitialized) {
                logMsg = {
                    logId: util.uuid4(),
                    timeTaken: logMessage.timeTaken,
                    timeStamp: util.getUtcTime(),
                    logCategory: logMessage.logCategory,
                    logLevel: logMessage.logLevel,
                    parentGuid: logMessage.parentGuid,
                    requestId: logMessage.requestId,
                    isMethodEnter: logMessage.isMethodEnter,
                    api: logMessage.api,
                    scenarioName: logMessage.scenarioName,
                    scenarioId: logMessage.scenarioName,
                    sessionId: logMessage.sessionId,
                    userId: logMessage.userId,
                    message: logMessage.message,
                    customerId: logMessage.customerId,
                    accountId: logMessage.accountId,
                    lcid: logMessage.lcid,
                    device: logMessage.device,
                    url: logMessage.url || '',
                    pass: logMessage.pass,
                    httpMethod: logMessage.httpMethod,
                    activityName: logMessage.parentGuid,
                    activityId: logMessage.parentGuid,
                    appSubSystemName: logMessage.appSubSystemName,
                };

                ariaAppLogListener.write(logMsg);
                consoleListener.write(logMsg);
            }
        },

        logClickEvent: function (e) {
          this.logEvent(this.logCategory.CLICKEVENT, { event: e });
        },

        logKeydownEvent: function (e) {
          var shouldLog = (e.which || e.keyCode) && _.some(EventFormatter.KEYS_TO_CAPTURE, function (KEY) { return KEY.keyCode === (e.which || e.keyCode); });

          if (shouldLog) {
            this.logEvent(this.logCategory.KEYBOARDEVENT, { event: e, keyEventType: 'keydown' });
          }
        },

        logChangeEvent: function (e) {
          var shouldLog = _.some([
            e.target.nodeName.toLowerCase() === 'select',
            e.target.nodeName.toLowerCase() === 'textarea',
            e.target.nodeName.toLowerCase() === 'input',
          ]);

          if (shouldLog) {
            this.logEvent(this.logCategory.INPUTCHANGEEVENT, { event: e });
          }
        },

        logPageRouteChange: function(isFullPageRefresh, eventDetails) {
          this.logEvent(this.logCategory.ROUTECHANGEEVENT,
            _.extend({ isFullPageRefresh: isFullPageRefresh }, eventDetails));
        },

        logFullPageLoad: function() {
          var self = this;
          self.logPageRouteChange(true, {
            isEnter: true,
            isUnload: false,
          });

          // The timestamp here is for calculating the time user spent on the page
          // so it doesn't require high accuracy and precision of when it starts.
          var pageLoadTime = util.getLogTimestamp();
          var logFullPageUnload = function () {
            var stayDuration = util.getLogTimestamp() - pageLoadTime;
            self.logPageRouteChange(true, {
              timeTaken: stayDuration,
              isEnter: false,
              isUnload: true,
            });
          };
          window.addEventListener('beforeunload', logFullPageUnload);
        },

        logPageRouteStart: function(pagePath, viewName, previousPath, previousView) {
          var activityId = util.uuid4();
          this.logPageRouteChange(false, {
            isEnter: true,
            isUnload: false,
            pageRoute: pagePath,
            viewName: viewName,
            activityId: activityId,
            previousRoute: previousPath,
            previousView: previousView,
          });
          return activityId;
        },

        logPageRouteNavigationDuration: function(pagePath, loadDuration, isRecorded) {
          var activityId = util.uuid4();
          this.logPageRouteChange(false, {
            isNavigation: true,
            pageRoute: pagePath,
            activityId: activityId,
            timeTaken: loadDuration,
            isRecorded: isRecorded,
          });
          return activityId;
        },

        logPageRouteEnd: function(pagePath, viewName, activityId, stayDuration, nextPagePath, isUnload) {
          this.logPageRouteChange(false, {
            isEnter: false,
            pageRoute: pagePath,
            viewName: viewName,
            activityId: activityId,
            timeTaken: stayDuration,
            nextRoute: nextPagePath,
            isUnload: isUnload,
          });
        },

        logEvent: function(logCategory, customFields) {
          if (!isInitialized) {
            return;
          }

          var self = this;

          if (LOGCATEGORY.TRACE > self.options.applicationLogLevel.value) {
            return;
          }

          var activityId = scenarioNameIdMapping[self.options.getScenarioName()],
            activity = activities[activityId],
            scenarioName = util.isObject(activity) ? activity.scenarioName : self.options.getScenarioName();

          var baseFields = {
            logId: util.uuid4(),
            timeStamp: util.getUtcTime(),
            appSubSystemName: self.options.getAppSubSystemNameFunc(),
            logCategory: logCategory,
            logLevel: self.logLevel.INFO,
            requestId: self.options.getRequestIdFunc(),
            sessionId: self.options.getSessionIdFunc(),
            userId: self.options.getUserIdFunc(),
            customerId: self.options.getCustomerIdFunc(),
            accountId: self.options.getAccountIdFunc(),
            lcid: self.options.getLcidFunc(),
            device: self.options.getDeviceFunc(),
            url: window.location.href,
            pageRoute: window.location.pathname,
            scenarioName: scenarioName,
            activityId: activityId,
          };

          var logMsg = _.extend(baseFields, customFields);

          ariaAppLogListener.write(logMsg);
          consoleListener.write(logMsg);
        },

        start: function (scenarioName, automaticEnd, onlyIncludeSpecifiedAjaxCalls, message) {
            if (!isInitialized) {
                return '';
            }

            var activityId = util.uuid4();

            isOnlyIncludeSpecifiedAjaxCalls = util.isUndefined(onlyIncludeSpecifiedAjaxCalls) ? false : onlyIncludeSpecifiedAjaxCalls;

            scenarioNameIdMapping[scenarioName] = activityId;

            var activity = {
                id: activityId,
                scenarioName: scenarioName,
                pass: true,
                activityCallbackCount: 0,
                startTime: util.getLogTimestamp(),
                timeStamp: util.getUtcTime(),
                duration: 0,
                appSubSystemName: activityManager.options.getAppSubSystemNameFunc(),
                requestId: activityManager.options.getRequestIdFunc(),
                sessionId: activityManager.options.getSessionIdFunc(),
                customerId: activityManager.options.getCustomerIdFunc(),
                accountId: activityManager.options.getAccountIdFunc(),
                userId: activityManager.options.getUserIdFunc(),
                lcid: activityManager.options.getLcidFunc(),
                device: activityManager.options.getDeviceFunc(),
                url: window.location.href,
                isEnded: false,
                logCategory: [activityManager.logCategory.PERFORMANCE, activityManager.logCategory.TRACE],
                logLevel: activityManager.logLevel.INFO,
                isAutomaticEnd: util.isUndefined(automaticEnd) ? true : automaticEnd,
            };

            activities[activityId] = activity;

            this._log({
                logCategory: [activityManager.logCategory.PERFORMANCE, activityManager.logCategory.TRACE],
                logLevel: activityManager.logLevel.INFO,
                parentGuid: activityId,
                requestId: activity.requestId,
                isMethodEnter: true,
                api: scenarioName,
                scenarioName: scenarioName,
                sessionId: activity.sessionId,
                userId: activity.userId,
                message: message,
                customerId: activity.customerId,
                accountId: activity.accountId,
                lcid: activity.lcid,
                device: activity.device,
                url: activity.url,
                appSubSystemName: activity.appSubSystemName,
            });

            return activityId;
        },

        wrap: function (scenarioName, func) {
            var funcArgs,
                result;

            if (isInitialized) {
                activityManager.start(scenarioName);
            }

            funcArgs = Array.prototype.slice.call(arguments, 2);
            if (funcArgs.length > 0) {
                result = func.apply(this, funcArgs);
            } else {
                result = func.call(this);
            }
            return result;
        },

        endByScenarioName: function (scenarioName, result, message) {
            if (!isInitialized) {
                return;
            }

            var activityId = scenarioNameIdMapping[scenarioName];
            if (util.isUndefined(activityId)) {
                return;
            }

            this.end(activityId, result, message);
        },

        end: function (activityId, result, message) {
            var activity = activities[activityId],
                t0 = activity.startTime,
                self = this,
                scenarioName = activity.scenarioName;
            if (!isInitialized) {
                return;
            }

            if (!activities.hasOwnProperty(activityId)) {
                return;
            }


            if (t0 === undefined) {
                return;
            }

            var timeTaken = util.getLogTimestamp() - t0,
                pass = !util.isUndefined(result) ? result : activity.pass;

            self._log({
                appSubSystemName: activity.appSubSystemName,
                logCategory: [self.logCategory.PERFORMANCE, self.logCategory.TRACE],
                logLevel: self.logLevel.INFO,
                parentGuid: activityId,
                requestId: activity.requestId,
                isMethodEnter: false,
                api: scenarioName,
                scenarioName: scenarioName,
                message: message,
                sessionId: activity.sessionId,
                userId: activity.userId,
                customerId: activity.customerId,
                accountId: activity.accountId,
                lcid: activity.lcid,
                device: activity.device,
                url: activity.url,
                timeTaken: timeTaken,
                pass: pass
            });

            delete activities[activityId];
            delete scenarioNameIdMapping[scenarioName];
        },

        changeResult: function (activityId, result) {
            if (!isInitialized) {
                return;
            }

            if (!util.isUndefined(activities[activityId])) {
                activities[activityId] = result;
            }
        },

        logDuration: function (func, logCategory, logLevel, methodName, message, activityId) {
            if (!isInitialized) {
                return;
            }

            var self = this;
            if (logLevel.value > self.options.applicationLogLevel.value) {
                return;
            }

            if (util.isUndefined(activityId)) {
                activityId = scenarioNameIdMapping[self.options.getScenarioName()];
            }

            var t0 = util.getLogTimestamp(),
                appSubSystemName = self.options.getAppSubSystemNameFunc(),
                activity = activities[activityId],
                scenarioName = util.isObject(activity) ? activity.scenarioName : self.options.getScenarioName(),
                customerId = self.options.getCustomerIdFunc(),
                accountId = self.options.getAccountIdFunc(),
                sessionId = self.options.getSessionIdFunc(),
                userId = self.options.getUserIdFunc(),
                lcid = self.options.getLcidFunc(),
                device = self.options.getDeviceFunc(),
                url = window.location.href,
                timeTaken=0;

            pushToTiming(true);

            func();
            timeTaken = util.getLogTimestamp() - t0;

            pushToTiming(false);

            function pushToTiming(isMethodEnter) {
                self._log({
                    logCategory: $.isArray(logCategory) ? logCategory : [self.LogCategory.TRACE, self.LogCategory.PERFORMANCE],
                    logLevel: util.isUndefined(logLevel) ? [self.logLevel.INFO] : logLevel,
                    parentGuid: activityId,
                    timeTaken: timeTaken,
                    isMethodEnter: isMethodEnter,
                    api: methodName,
                    message: message,
                    customerId: customerId,
                    accountId: accountId,
                    sessionId: sessionId,
                    userId: userId,
                    lcid: lcid,
                    device: device,
                    url: url,
                    scenarioName: scenarioName,
                    appSubSystemName: appSubSystemName,
                });
            }
        },

        logMessage: function (message, methodName, logCategory, logLevel, activityId, requestId) {
            if (!isInitialized) {
                return;
            }

            var self = this;
            if (logLevel.value > self.options.applicationLogLevel.value) {
                return;
            }

            if (util.isUndefined(activityId)) {
                activityId = scenarioNameIdMapping[self.options.getScenarioName()];
            }
            var activity = activities[activityId],
                appSubSystemName = self.options.getAppSubSystemNameFunc(),
                scenarioName = util.isObject(activity) ? activity.scenarioName : self.options.getScenarioName(),
                customerId = self.options.getCustomerIdFunc(),
                accountId = self.options.getAccountIdFunc(),
                requestId = self.options.getRequestIdFunc(),
                sessionId = self.options.getSessionIdFunc(),
                userId = self.options.getUserIdFunc(),
                lcid = self.options.getLcidFunc(),
                device = self.options.getDeviceFunc();
                url = window.location.href;
            var category = $.isArray(logCategory) ? logCategory : [self.logCategory.TRACE];

            if (category.indexOf(self.logCategory.ERROR) !== -1 && window.clarity && message && typeof message === 'string') {
                // Clarity custom tags: https://docs.microsoft.com/en-us/clarity/custom-tags
                window.clarity('set', 'ClientCenterGlobalError', message.slice(0, 100));
            }

            self._log({
                logCategory: category,
                logLevel: util.isUndefined(logLevel) ? self.logLevel.INFO : logLevel,
                parentGuid: activityId,
                requestId: util.isUndefined(requestId) ? '' : requestId,
                message: message,
                api: methodName,
                customerId: customerId,
                accountId: accountId,
                sessionId: sessionId,
                userId: userId,
                lcid: lcid,
                device: device,
                url: url,
                scenarioName: scenarioName,
                appSubSystemName: appSubSystemName,
            });
        },

        _logAjax: function(ajaxGuid, url, activityId, isMethodEnter, httpMethod, timeTaken, ajaxResult, message) {
            var self = this,
                activity = activities[activityId],
                scenarioName = util.isObject(activity) ? activity.scenarioName : self.options.getScenarioName();

            self._log({
                logCategory: [self.logCategory.PERFORMANCE, self.logCategory.TRACE],
                logLevel: self.logLevel.INFO,
                parentGuid: activityId,
                requestId: ajaxGuid,
                api: url,
                isMethodEnter: isMethodEnter,
                timeTaken: timeTaken,
                pass: ajaxResult,
                customerId: self.options.getCustomerIdFunc(),
                accountId: self.options.getAccountIdFunc(),
                sessionId: self.options.getSessionIdFunc(),
                userId: self.options.getUserIdFunc(),
                lcid: self.options.getLcidFunc(),
                device: self.options.getDeviceFunc(),
                scenarioName: scenarioName,
                httpMethod: httpMethod,
                message: message,
                appSubSystemName: self.options.getAppSubSystemNameFunc(),
            });
        },

        //method to automatically detect method end
        _detectEnd: function(activityId) {
            var count = activities[activityId].activityCallbackCount;

            if (count === 0) {
                this.end(activityId);
            }
        },

        _stubAjax: function(jQuery) {
            var originalAjax = jQuery.ajax,
                self = this;

            jQuery.ajax = function(url, options) {

                if (typeof url === 'object') {
                    options = url;
                }

                options = options || {};

                var bypassAjaxLogging = util.isUndefined(options.bypassAjaxLogging) ? false : options.bypassAjaxLogging,
                    requestId,
                    localActivityId,
                    requestResult,
                    httpMethod,
                    error,
                    ajaxStartTime;

                if (!bypassAjaxLogging && options.url.toLowerCase().indexOf('bingads') != -1) {
                    if ((util.isUndefined(options.dataType) || options.dataType !== 'script') &&
                        !util.isUndefined(options.url) &&
                        options.url.indexOf('ReqId') === -1 &&
                        options.url.toLowerCase().indexOf('scripts/') === -1) {
                            requestId = util.uuid4();
                            options.url = util.setUrlParameter('ReqId', requestId, options.url);
                    }
                    localActivityId = util.isUndefined(options.activityId) ? '' : options.activityId;
                    requestResult = true;
                    httpMethod = options.type;
                    error = '';

                    stubEventHandler(event.BEFORESEND, options, beforeSendActivityTracking);
                    stubEventHandler(event.SUCCESS, options, successActivityTracking);
                    stubEventHandler(event.ERROR, options, errorActivityTracking);
                    stubEventHandler(event.COMPLETE, options, completeActivityTracking);
                    ajaxStartTime = util.getLogTimestamp();
                }

                return originalAjax.apply(jQuery, arguments);

                function stubEventHandler(eventName, ajaxOptions, activityTracking) {
                    if (util.isUndefined(ajaxOptions[eventName])) {
                        ajaxOptions[eventName] = function() {
                            activityTracking.apply(this, arguments);
                        };
                    } else if ($.isFunction(ajaxOptions[eventName])) {
                        var originalEventHandler = ajaxOptions[eventName];
                        ajaxOptions[eventName] = function() {
                            activityTracking.apply(this, arguments);
                            try {
                                return originalEventHandler.apply(this, arguments);
                            } catch (ex) {
                                if (!util.isUndefined(activities[localActivityId]))
                                    activities[localActivityId].pass = false;
                                requestResult = false;
                                if (!ex.message) {
                                    error = ex.toString();
                                }else if (!ex.stack) {
                                    error = ex.message;
                                } else {
                                    error = ex.message + '\tStackTrace: ' + ex.stack;
                                }
                                self.logMessage(error, this.url, [self.logCategory.ERROR], self.logLevel.INFO, localActivityId, requestId);
                                throw ex;
                            }
                        };
                    }
                }

                function beforeSendActivityTracking(jqXHR) {
                    jqXHR.setRequestHeader('x-ms-requestid', requestId);

                    if (!util.isUndefined(activities[localActivityId])) {
                        activities[localActivityId].activityCallbackCount++;
                    }
                    self._logAjax(requestId, this.url, localActivityId, true, httpMethod);
                }

                function successActivityTracking(data) {
                    var result;
                    result = self.options.detectError(data);

                    if (!result.pass) {
                        if (!util.isUndefined(activities[localActivityId])) {
                            activities[localActivityId].pass = result.pass;
                        }

                        requestResult = false;
                        error = result.message;
                        self.logMessage(error, this.url, [self.logCategory.ERROR], self.logLevel.INFO, localActivityId, requestId);
                    }
                }

                function errorActivityTracking(jqXHR, textStatus, errorThrown) {
                    if (jqXHR.status != 0) {
                        requestResult = false;
                        if (!util.isUndefined(activities[localActivityId])) {
                            activities[localActivityId].pass = false;
                        }

                        error = 'Ajax error [' + jqXHR.status + '], ';

                        if (textStatus && $.trim(textStatus) !== '') {
                            error += textStatus + ', ';
                        }

                        if (errorThrown && $.trim(errorThrown) !== '') {
                            error += errorThrown;
                        }

                        self.logMessage(error, this.url, [self.logCategory.ERROR], self.logLevel.INFO, localActivityId, requestId);
                    }
                }

                function completeActivityTracking() {
                    var ajaxTimeTaken = util.getLogTimestamp() - ajaxStartTime;
                    var activity = activities[localActivityId];
                    self._logAjax(requestId, this.url, localActivityId, false, httpMethod, ajaxTimeTaken, requestResult, error);

                    if (!util.isUndefined(activity)) {
                        activity.activityCallbackCount--; //decrease count on complete
                        if (activity.isAutomaticEnd) {
                            self._detectEnd(localActivityId);
                        }
                    }
                }
            };
        },

        getActivityId: function (scenarioName) {
            return scenarioNameIdMapping[scenarioName];
        },
    };

    return activityManager;
});
